/* cf-abar-rotate.js - Click Fencing, 2026-10-09.
 * Pete: "make the delivery bar fit on 2 lines", then chose "Alternate the two offers" (his exact words,
 * split in two). The bar's text is two offers joined by "|":
 *   FREE delivery on hardware orders over $300, Australia-wide | FREE delivery within 70 km of our
 *   Canning Vale warehouse on orders over $3,000
 * On a phone that is 3 lines at any readable size. Phones (<=749px) now show one offer at a time, 2 lines
 * each, swapping every 5 seconds. The words are read from the bar itself, so a change made in the Shopify
 * theme editor carries straight through. The bar keeps one fixed height (the taller offer), so nothing
 * below it moves. Desktop: untouched. With "reduce motion" on, it swaps without the fade.
 * Display only. Roll back: remove its line from snippets/cf-mobile-extra.liquid.
 */
(function () {
  'use strict';
  if (window.__cfAbarRotate) return;
  window.__cfAbarRotate = true;
  var MQ = window.matchMedia('(max-width: 749px)');
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;
    var span = bar.querySelector('span') || bar;
    if (span.getAttribute('data-cf-abar')) return;
    var text = (span.textContent || '').trim();
    var parts = text.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (parts.length < 2) return;
    span.setAttribute('data-cf-abar', '1');

    var css = document.createElement('style');
    css.textContent = [
      '.cf-abar-alt{display:none}',
      '@media (max-width:749px){',
      '  [data-cf-abar] > .cf-abar-full{display:none}',
      '  [data-cf-abar] > .cf-abar-alt{display:block;transition:opacity .35s;text-wrap:balance}',
      '  [data-cf-abar] > .cf-abar-alt[hidden]{display:none!important}',
      '  [data-cf-abar] > .cf-abar-alt.cf-out{opacity:0}',
      '}'
    ].join('\n');
    document.head.appendChild(css);

    // the full text stays in the page (desktop, screen readers); phones show the parts
    var full = document.createElement('span');
    full.className = 'cf-abar-full';
    full.textContent = text;
    span.textContent = '';
    span.appendChild(full);
    var alts = parts.map(function (p, i) {
      var s = document.createElement('span');
      s.className = 'cf-abar-alt';
      s.setAttribute('aria-hidden', 'true');
      s.textContent = p;
      if (i) s.hidden = true;
      span.appendChild(s);
      return s;
    });

    // one fixed height: the taller part
    function fixHeight() {
      span.style.minHeight = '';
      if (!MQ.matches) return;
      var h = 0;
      alts.forEach(function (s) {
        var was = s.hidden; s.hidden = false;
        h = Math.max(h, s.getBoundingClientRect().height);
        s.hidden = was;
      });
      if (h) { span.style.display = 'block'; span.style.minHeight = Math.ceil(h) + 'px'; }
    }
    fixHeight();
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; fixHeight(); } });

    var cur = 0;
    setInterval(function () {
      if (!MQ.matches || document.hidden) return;
      var a = alts[cur], next = (cur + 1) % alts.length, b = alts[next];
      if (REDUCE) { a.hidden = true; b.hidden = false; cur = next; return; }
      a.classList.add('cf-out');
      setTimeout(function () {
        a.hidden = true; a.classList.remove('cf-out');
        b.classList.add('cf-out'); b.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.remove('cf-out'); }); });
        cur = next;
      }, 350);
    }, 5000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
